import React from 'react'
import heart from "../../assets/img/menudropbox/heart-circle.svg"
import card from "../../assets/img/menudropbox/card-pos.svg"
import notification from "../../assets/img/menudropbox/sms-notification.svg"
import qusetion from "../../assets/img/menudropbox/message-question.svg"
import leftArrow from "../../assets/img/icons/arrow-left-green.svg"
import { Link } from 'react-router-dom'
import { useUserInfo } from '../../context/UserContext'
import PersianNumber from '../shared/PersianNumber'
const UserDropbox = () => {
  const { userinfo} = useUserInfo()
  return (
    <div className='UserDropbox'>
       <div className='UserDropbox--headerbox'>
       <div className='UserDropbox--header '>
            <h4>سجاد لطیفی</h4>
         <Link to="/user">
         <div className='d-flex-space'>
               <p>مشاهده حساب کاربری</p>
               <img src={leftArrow}/>

           </div></Link>
        </div>
        <hr className='my-[12px]'/>
        <ul>
           <Link to='/user/wishlist'>
           <li className='flex gap-[12px]'>
                <img src={heart}/>
                <p>علاقه مندی ها</p>
            </li></Link>
            <hr className='my-[12px]'/>
           <Link to='/user/wallet'>
           <li className='d-flex-space'>
                <div className='flex gap-[12px]'>
                <img src={card}/>
                <p>موجودی حساب</p>
                </div>
                <div>
                <PersianNumber number={userinfo.data.wallet_amount}/> تومان
                </div>
            </li>
           </Link>

         {/* <Link to='/user/notification'>
         <li className='d-flex-space'>
                <div className='flex gap-[12px]'>
                <img src={notification}/>
                <p> اعلانات و پیام ها</p>
                </div>
                <div className='not-num'>
                ۱۴
                </div>
            </li></Link> */}
        </ul>

       </div>
       <ul className='px-[12px] mt-[20px]'>
           <li className='pr-[35px]'>پشتیبانی سایت</li>
           <hr className='my-[12px]'/>
           <Link to='/faq'>
              <li className='flex gap-[12px]'>
                <img src={qusetion}/>
                <p>پرسش ها و سوالات متداول</p>
            </li>
           </Link>
          
         

       </ul>
        
    </div>
  )
}

export default UserDropbox